import api from '../api'
import messages from '../messages'

const initialState = { loggedIn: (localStorage.isLogin == 'true'), user: null };

export const auth = {
    namespaced: true,
    state: initialState,
    actions: {

        login({ commit }, obj) {
            let loader = document.getElementById('loader');
            loader.classList.add("show");

            return api.login(obj).then(response => {
                    loader.classList.remove("show");
                    commit('loginSuccess', response.data);
                    return Promise.resolve(response.data);
                },
                error => {
                    loader.classList.remove("show");
                    api.baseErrorHendler(error);
                    commit('loginFailure');
                    return Promise.reject(error);
                });
        },

        logout({ commit }) {
            return api.logout().then(response => {
                    commit('logout');
                    return Promise.resolve(true);
                },
                error => {
                    api.baseErrorHendler(error);
                    return Promise.reject(error);
                });
        },

        getMe({ commit }, cache){
            if((cache == undefined || cache == false) && this.state.user != null) 
                return Promise.resolve(this.state.user);
            
            return api.me().then(function (response) {
                    commit('getMe', response.data);
                    return Promise.resolve(response.data);
                })
                .catch(function (error) {
                    api.baseErrorHendler(error);
                    commit('getMeFailure', error);
                    return Promise.reject(error);
                });
        },

        setUser({ commit }, user){
            commit('getMe', user);
            return Promise.resolve(user);
        }

    },
    mutations: {
        loginSuccess(state, user) {
            state.loggedIn = true;
            localStorage.isLogin = true;
            state.user = user;
        },
        loginFailure(state) {
            state.loggedIn = false;
            localStorage.isLogin = false;
            state.user = null;
        },
        logout(state) {
            state.loggedIn = false;
            localStorage.isLogin = false;
            state.user = null;
            messages.deleteToken();
            localStorage.removeItem('nToken');
        },

        getMeFailure(state, err) {
            if(err.response.status == 401){
                state.loggedIn = false;
                localStorage.isLogin = false;
                state.user = null;
                messages.deleteToken();
                localStorage.removeItem('nToken');
            }
        },
        getMe(state, user) {
            state.loggedIn = true;
            localStorage.isLogin = true;
            state.user = user;
        }
    }
};